export default __webpack_public_path__ + "static/media/pictogramBeaconLock40.376abc69.svg";